import { P2TextLabel } from 'react-bootstrap-common-script';
import { Separator } from '../../../../components/separator';
import useViewportWidth from '../../../../components/stepper/useViewportWidth';
import { Helpers } from '../../../../utils/helper';

interface CpfWithdrawalDetailsProps {
  cpfWithdrawalDetails: any;
}

function CpfWithdrawalDetails({ cpfWithdrawalDetails }: CpfWithdrawalDetailsProps) {
  const isDesktopView = useViewportWidth();

  return (
    <>
      <div className='cpf-container' style={{ gap: '16px' }}>
        <div>
          <P2TextLabel
            bold={700}
            label={'CPF Withdrawal Details'}
            fontSize={isDesktopView ? '24px' : '20px'}
            lineHeight={isDesktopView ? '28px' : '22px'}
          />
        </div>

        <div className='polymer-stage-e_cpf-details'>
          <div className='polymer-stage-e_cpf-details_entry'>
            <P2TextLabel label={'Total CPF withdrawal*'} bold={'700'} />
            {cpfWithdrawalDetails?.withdrawalAmount !== undefined && cpfWithdrawalDetails?.withdrawalAmount !== null && (
              <div className='description'>
                <P2TextLabel label={`$${Helpers.formatThousandSeparator(cpfWithdrawalDetails?.withdrawalAmount)}`} bold={'700'} />
              </div>
            )}
          </div>

          <Separator variant='solid' />
          <div className='polymer-stage-e_cpf-details_entry'>
            <P2TextLabel label={'Stamp fee'} bold={'700'} />
            {cpfWithdrawalDetails?.fees?.stamp !== undefined && cpfWithdrawalDetails?.fees?.stamp !== null && (
              <div className='description'>
                <P2TextLabel label={`$${Helpers.formatThousandSeparator(cpfWithdrawalDetails?.fees?.stamp)}`} bold={'400'} />
              </div>
            )}
          </div>

          <Separator />
          <div className='polymer-stage-e_cpf-details_entry'>
            <P2TextLabel label={'Conveyancing Fee'} bold={'700'} />
            {cpfWithdrawalDetails?.fees?.conveyancing !== undefined && cpfWithdrawalDetails?.fees?.conveyancing !== null && (
              <div className='description'>
                <P2TextLabel label={`$${Helpers.formatThousandSeparator(cpfWithdrawalDetails?.fees?.conveyancing)}`} bold={'400'} />
              </div>
            )}
          </div>

          <Separator />
          <div className='polymer-stage-e_cpf-details_entry'>
            <P2TextLabel label={'Registration Fee'} bold={'700'} />
            {cpfWithdrawalDetails?.fees?.conveyancing !== undefined && cpfWithdrawalDetails?.fees?.registration !== null && (
              <div className='description'>
                <P2TextLabel label={`$${Helpers.formatThousandSeparator(cpfWithdrawalDetails?.fees?.registration)}`} bold={'400'} />
              </div>
            )}
          </div>

          <Separator />
          <div className='polymer-stage-e_cpf-details_entry'>
            <P2TextLabel label={'Lump sum payment for ownership change'} bold={'700'} />
            {cpfWithdrawalDetails?.fees?.lump_sum !== undefined && cpfWithdrawalDetails?.fees?.lump_sum !== null && (
              <div className='description'>
                <P2TextLabel label={`$${Helpers.formatThousandSeparator(cpfWithdrawalDetails?.fees?.lump_sum)}`} bold={'400'} />
              </div>
            )}
          </div>
        </div>
        {cpfWithdrawalDetails && cpfWithdrawalDetails?.ra_to_oa > 0 && (
          <div>
            <P2TextLabel
              label={`* Inclusive of your Ordinary Account savings and amount to be transferred from your Retirement Account to Ordinary Account for housing of $${Helpers.formatThousandSeparator(
                cpfWithdrawalDetails?.ra_to_oa
              )}`}
              color='#323232'
              fontSize={'14px'}
              lineHeight={'20px'}
              bold={500}
              marginBottom={'0'}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default CpfWithdrawalDetails;
